import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import api from '../api'
import type { Drop, CreateDropDTO, UpdateDropDTO } from '../admin/drops.service'

export type { Drop, CreateDropDTO, UpdateDropDTO }

// Super-admin pode escolher empresa ou criar global
export interface SuperAdminCreateDropDTO extends CreateDropDTO {
  companyId?: string | null
}

export interface SuperAdminUpdateDropDTO extends UpdateDropDTO {
  companyId?: string | null
}

// Super-admin hooks
export function useSuperAdminDrops(enabled = true) {
  return useQuery({
    queryKey: ['super-admin-drops'],
    queryFn: async () => {
      const { data } = await api.get<Drop[]>('/super-admin/drops')
      return data
    },
    enabled,
  })
}

export function useSuperAdminCreateDrop() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (dto: SuperAdminCreateDropDTO) => {
      const { data } = await api.post<Drop>('/super-admin/drops', dto)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['super-admin-drops'] })
    },
  })
}

export function useSuperAdminUpdateDrop() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, ...dto }: SuperAdminUpdateDropDTO & { id: number }) => {
      const { data } = await api.put<Drop>(`/super-admin/drops/${id}`, dto)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['super-admin-drops'] })
    },
  })
}

export function useSuperAdminDeleteDrop() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: number) => {
      await api.delete(`/super-admin/drops/${id}`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['super-admin-drops'] })
    },
  })
}
